// window.lazySizesConfig = window.lazySizesConfig || {};
// lazySizesConfig.loadMode = 1;
// import 'lazysizes';
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupGiaPlugin from '@swup/gia-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';



import Component from 'gia/Component';
import loadComponents from 'gia/loadComponents';
import eventbus from 'gia/eventbus';
import getComponentFromElement from 'gia/getComponentFromElement';
import removeComponents from 'gia/removeComponents';


import Slider from './slider'
import Cover from './cover'
import Fyi from './fyi'
import Sticky from './sticky'
import config from 'gia/config';


class App {

  constructor($) {
    this.create()
  }

  create(){

    const components = {

        Cover: Cover,
        Fyi: Fyi,
        Slider: Slider,
        Sticky: Sticky
    }

    config.set('log', false);

    loadComponents(components)


  }

}


module.exports = App
